import  axiosI  from '../Service/service';
import { CREATE_DEAL,GET_DEAL,UPDATE_DEAL,GET_POTENTIAL_COUNT,ENABLE,DISABLE, DELETE_DEAL } from './actionTypes';
import * as constants from '../Constants';

export const createDeal=(deal)=>{
  let dealData={results:deal}
    return (dispatch => {
      dispatch({type: ENABLE, payload: true});
        return axiosI.post(constants.API.addBusinessDealApi,deal.BusinessDeal).then(({data}) => {
          dealData.results.BusinessDeal.DealID=data.results.BusinessDeal.DealID;
            dispatch({
                type: CREATE_DEAL,
                payload:dealData
            });
          dispatch({type: DISABLE, payload: false});
          return data;
        })
    })
};
export const GetDeal=(placeID)=>{
    return (dispatch => {
      return axiosI.get(`${constants.API.getCurrentDealApi}/${placeID}`).then(({data})=>{
        dispatch({
          type:GET_DEAL,
          payload: data
        });
        return data;
      })
    })
};

export const DeleteDeal=(dealId)=>{

  return (dispatch => {
    dispatch({type: ENABLE, payload: true});

    return axiosI.post(constants.API.deleteBusinessDealsByDealIdApi, {DealID: dealId}).then(({data})=>{

      dispatch({
        type:DELETE_DEAL,
        payload: data
      });
      dispatch({type: DISABLE, payload: false});
      return data;
    })
  })
};

export const UpdateDeal=(deal)=>{
  const dealData={results:deal};
  return (dispatch => {
    dispatch({type: ENABLE, payload: true});
    return axiosI.post(constants.API.addBusinessDealApi,deal.BusinessDeal).then(({data}) => {
      dispatch({
        type: UPDATE_DEAL,
        payload: data.results.ResponseCode?dealData:data
      });
      dispatch({type: DISABLE, payload: false});
      return data;
    }).catch((error)=>{
      console.log('error',error);
    })
  })
};
export const GetPotential=(userId,lat,long,type)=>{

  return (dispatch => {
      dispatch({
          type: "REFETCH_COUNT",
      });
    return axiosI.get(`${constants.API.getPotentialReachCountApi}/${userId}/${lat}/${long}/15/${type}`).then(({data}) => {
      dispatch({
        type: GET_POTENTIAL_COUNT,
        payload: data
      });
      return data;
    }).catch((error)=>{
      console.log('error',error);
    })
  })
};